import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ObjectFloat from './objects/ObjectFloat';
import { BRANCHES, LOWEST_PRICE_USD, formatUsd } from '../data/catalog';
import '../styles/Tracks.css';

const TrackChooser: React.FC = () => {
  return (
    <section id="tracks" className="section tracks">
      <div className="obj-spot spot-kite" aria-hidden="true"><ObjectFloat slug="kite" /></div>
      <div className="container">
        <div className="section-head" data-reveal>
          <p className="section-eyebrow">Our services</p>
          <h2 className="section-title">Looking into starting a career in these industries?</h2>
          <p className="section-intro">We&apos;re ready to help you in these fields.</p>
        </div>

        <div className="track-grid">
          {BRANCHES.map((branch, index) => (
            <article
              key={branch.id}
              className="track-card bracketed"
              data-reveal
              style={{ ['--reveal-delay' as string]: `${index * 0.1}s` }}
            >
              <p className="track-kicker">{branch.shortName}</p>
              <h3 className="track-name">{branch.name}</h3>
              <ul className="check-list track-drills">
                {branch.drills.map(drill => (
                  <li key={drill}>{drill}</li>
                ))}
              </ul>
              <div className="track-foot">
                <p className="price-note">From {formatUsd(LOWEST_PRICE_USD)}</p>
                <Link className="btn btn-primary track-cta" to={`/${branch.id}`}>
                  See {branch.shortName} prep
                  <ArrowRight size={16} aria-hidden="true" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrackChooser;
